<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .modal-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: colors.get(primary_50);
    width: calc(100% + 2rem);
    margin: -1rem;
    padding: 1rem 1.5rem;
    box-sizing: border-box;
  }

  .title {
    color: white;
    margin: 0;
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 240px);
    max-height: utils.in_rem(600px);
    min-height: utils.in_rem(400px);
  }

  .form-content {
    display: flex;
    padding: utils.in_rem(24px) utils.in_rem(24px) 0 utils.in_rem(24px);
    flex-direction: column;
    gap: utils.in_rem(20px);
    flex: 1;
    overflow-y: auto;
    min-height: 0; /* Allows content to shrink */
  }
</style>

<script>
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { adminCreate } from "../../../../api/admin";
  import AdminToggle from "./components/AdminToggle.svelte";
  import AliasRows from "./components/AliasRows.svelte";
  import EmailInput from "./components/EmailInput.svelte";
  import GroupSelector from "./components/GroupSelector.svelte";
  import LicenseSelector from "./components/LicenseSelector.svelte";
  import ModalFooter from "./components/ModalFooter.svelte";
  import UserTypeSelector from "./components/UserTypeSelector.svelte";
  import {
    addUsersPayloadStore,
    aliasRowsStore,
    emailStore,
    groupIdsStore,
    isAdminStore,
    kindStore,
    selectedLicenseKindsStore,
    showAddUsersModal,
    teamStore,
  } from "./stores";

  const onclose = () => {
    // Reset all stores
    emailStore.set([]);
    kindStore.set(""); // Reset to empty since user type is now optional
    isAdminStore.set(false);
    groupIdsStore.set([]);
    selectedLicenseKindsStore.set([]);
    aliasRowsStore.set([{ email: [], aliasUserId: "" }]);
    $showAddUsersModal = false;
  };

  const saveUser = async () => {
    const payload = $addUsersPayloadStore;
    await adminCreate({ kind: "user-invite", data: payload });
    onclose();
    teamStore.get();
    showToast({
      title: "Invitation Sent",
      type: "success",
    });
  };
</script>

{#if $showAddUsersModal}
  <Modal
    {onclose}
    size="medium"
    closeButton={false}
    modalContentsStyle="width: 700px;"
  >
    <div slot="header" class="modal-header-content">
      <h2 class="title">Add Users</h2>
    </div>

    <div class="modal-content">
      <div class="form-content">
        <UserTypeSelector />

        {#if $kindStore !== "alias"}
          <AdminToggle />
        {/if}

        {#if !["viewer", "alias"].includes($kindStore)}
          <LicenseSelector />
        {/if}

        {#if $kindStore !== "alias" && Object.entries($teamStore.teamGroups).length > 0}
          <GroupSelector />
        {/if}

        {#if $kindStore === "alias"}
          <AliasRows />
        {:else}
          <EmailInput />
        {/if}
      </div>

      <ModalFooter onSave={saveUser} cancel={onclose} />
    </div>
  </Modal>
{/if}
